import { Component, OnDestroy } from '@angular/core';
import { CoreSelectors } from '@next/core-lib';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';

import { FarmSettings } from '../../models/farm-settings.model';
import * as farmSettingsActions from '../../store/actions/farm-settings.actions';
import { getCurrentFarmSettings } from '../../store/selectors/farm-settings.selector';

@Component({
  selector: 'app-sustainability-overview',
  templateUrl: 'sustainability-overview.component.html',
  standalone: false,
})
export class SustainabilityOverviewComponent implements OnDestroy {
  private readonly destroyed$ = new Subject<void>();

  isLoading$: Observable<boolean> = this.store.select(CoreSelectors.selectLoading);
  farmSettings$: Observable<FarmSettings> = this.store.select(getCurrentFarmSettings);
  farmSettings: FarmSettings;
  enableCO2Calculation: boolean;

  constructor(private readonly store: Store<RootState>) {
    this.farmSettings$.pipe(takeUntil(this.destroyed$)).subscribe((farmSettings) => {
      this.enableCO2Calculation = farmSettings.enableCO2Calculation;
      this.farmSettings = farmSettings;
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onToggleCO2Calculation(newValue: boolean) {
    this.store.dispatch(
      farmSettingsActions.upsertFarmSettings({
        farmSettings: {
          ...this.farmSettings,
          enableCO2Calculation: newValue,
        },
      }),
    );
  }
}
